export default __webpack_public_path__ + "static/media/bit3.8157d654.svg";